module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_vm._m(0), _c('p', {
    staticClass: "site-copyright"
  }, [_vm._v("Copyright © 360商业数据部 2005-" + _vm._s(_vm.year) + " 360.CN All Rights Reserved 360分析 京ICP证080047号")]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "site-name"
  }, [_c('a', {
    attrs: {
      "href": "http://dmp.360.cn/",
      "target": "_blank"
    }
  }, [_vm._v("360DMP")]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": "http://shangyi.360.cn/",
      "target": "_blank"
    }
  }, [_vm._v("360商易")]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": "https://s4.qhimg.com/static/68681a638322a648.pdf",
      "target": "_blank"
    }
  }, [_vm._v("服务协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "site-copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000006"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": "http://p4.qhmsg.com/d/inn/f570feb7/ghs.png"
    }
  }), _vm._v("京公网安备 11000002000006号")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f06f919", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f06f919!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/footer.vue
// module id = 759
// module chunks = 0